import { FILTER_GROUP_MEMBERS } from './constants'

export const filterGroupMembers = (value, groupId, page) => ({
    type: FILTER_GROUP_MEMBERS,
    data: { value, groupId, page },
})
